/**
 * Routes that must never load third-party vendor scripts: `/charts` is the
 * embedded chart widget that other sites load in an iframe.
 *
 * Read live, at the moment a vendor is about to boot — vendor boots wait for
 * load + idle, and the visitor may have soft-navigated in the meantime.
 */
export const isVendorExcludedPath = (): boolean =>
    typeof window !== 'undefined' && window.location.pathname.startsWith('/charts');
